import React from "react";

export default function LoadingSpinner({ white = false }) {
	return (
		<div className="flex items-center justify-center">
			<div
				className={`w-6 h-6 border-4 rounded-full animate-spin ${
					white
						? "border-white border-t-transparent"
						: "border-blue-500 border-t-transparent"
				}`}
			></div>
		</div>
	);
}
